module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYBAMAAABkY5JAAAAAG1BMVEW8vLwAAABeXl4XFxdGRkaNjY2kpKR1dXUvLy/dd++OAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAhUlEQVQYlWNgGPRA2YRBWYTdgM2UydCBgckAJMRqlhxmlhHQxOIQnGbKEAwWY0tITgOKJRcnhDK4M7SCxRiYhRgURRiYxIHSBkxlEDEGsF6QWHJABBtUL0u5A5NCcnACWytDo6AgSIy9LTnULKOgicmBowCkHazV2QjsFgbTQkEJmNigBgB6ERfZnXbhcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/paypal.jpg
// module id = TUSe
// module chunks = 0